module.exports = __webpack_public_path__ + "img/icon-logo2.1fb76468.png";